import { render, staticRenderFns } from "./ProcList.vue?vue&type=template&id=ad577902&scoped=true"
import script from "./ProcList.vue?vue&type=script&lang=js"
export * from "./ProcList.vue?vue&type=script&lang=js"
import style0 from "./ProcList.vue?vue&type=style&index=0&id=ad577902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad577902",
  null
  
)

export default component.exports